var _styled;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// https://github.com/alphagov/govuk-frontend/tree/master/src/components/select
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BLACK, ERROR_COLOUR, YELLOW } from 'govuk-colours';
import { MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import Label from '@govuk-react/label';
import LabelText from '@govuk-react/label-text';
import ErrorText from '@govuk-react/error-text';
import HintText from '@govuk-react/hint-text';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledSelect = styled('select')((_styled = {
  boxSizing: 'border-box',
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: '16px',
  lineHeight: '1.25',
  width: '100%',
  height: '33px',
  padding: '5px 4px 4px',
  border: "2px solid " + BLACK
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  width: '50%',
  height: '38px',
  fontSize: '19px',
  lineHeight: '1.31579'
}, _styled[':focus'] = {
  outline: "3px solid " + YELLOW,
  outlineOffset: 0
}, _styled), function (_ref) {
  var error = _ref.error;
  return {
    border: error ? "4px solid " + ERROR_COLOUR : undefined
  };
});

var Select = function Select(_ref2) {
  var children = _ref2.children,
      hint = _ref2.hint,
      label = _ref2.label,
      meta = _ref2.meta,
      input = _ref2.input,
      className = _ref2.className;
  return React.createElement(Label, {
    className: className,
    error: meta.touched && meta.error
  }, React.createElement(LabelText, null, label), hint && React.createElement(HintText, null, hint), meta.touched && meta.error && React.createElement(ErrorText, null, meta.error), React.createElement(StyledSelect, _extends({
    error: meta.touched && meta.error
  }, input), children));
};

Select.defaultProps = {
  hint: undefined,
  errorText: undefined,
  className: undefined,
  input: {},
  meta: {}
};
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  hint: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any
  }),
  meta: PropTypes.shape({
    active: PropTypes.bool,
    dirty: PropTypes.bool,
    dirtySinceLastSubmit: PropTypes.bool,
    error: PropTypes.any,
    initial: PropTypes.bool,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitError: PropTypes.any,
    submitFailed: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool
  }),
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 6
})(Select);
export { StyledSelect as SelectInput };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/select/es/index.js
// module id = 92
// module chunks = 0